import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
import { Eyebrow } from './Eyebrow';
const terms = ['One email is enough', 'No forms to fill', 'Keep every file you downloaded'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="bg-night py-16 sm:py-24" data-id="element-165" data-mp="22126lgvq7eum">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-166" data-mp="1x28qrhsyvbra">
        <div className="grid gap-8 rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,20rem)] lg:gap-16" data-id="element-167" data-mp="19fskkkocgika">
          <div data-id="element-168" data-mp="14dtide4cbrox">
            <div className="flex items-center gap-4" data-id="element-169" data-mp="1j4ahurxf07j6">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber" data-id="element-170" data-mp="1j5v9o9schcdc">
                <ShieldCheckIcon className="h-6 w-6 text-night" aria-hidden="true" data-id="element-171" data-mp="1ebr2pqj2x4c9" />
              </span>
              <Eyebrow data-id="element-172" data-mp="qm6h0zvjjsza">Zero risk &middot; 100% protected</Eyebrow>
            </div>
            <h2 id="guarantee-heading" className="mt-6 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-173" data-mp="lowjsy1wud0w">
              10-day <span className="text-amber" data-id="element-174" data-mp="txtaz6so2xgk">money-back guarantee</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-cream-soft" data-id="element-175" data-mp="yot5y6i875gf">
              Open everything. Use the materials. Test them in real classes. If the Arsenal
              doesn&rsquo;t change how you plan and teach, email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-amber underline decoration-amber/40 underline-offset-2 transition-colors duration-150 ease-out hover:text-amber-light" data-id="element-176" data-mp="62i5cvumd4jm">
                {SUPPORT_EMAIL}
              </a>{' '}
              within 10 days of your purchase and we refund the full $27 &mdash; you don&rsquo;t need
              to explain why, and you keep the files you already downloaded.
            </p>
          </div>

          <div className="flex flex-col justify-center border-t border-night-600 pt-8 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-177" data-mp="1vholees7c2zl">
            <ul className="space-y-3" data-id="element-178" data-mp="3nhes4qgfhepu">
              {terms.map(term => <li key={term} className="text-sm uppercase tracking-label text-cream-soft" data-id="element-179" data-mp="3njhm1lkpbrzu">
                  {term}
                </li>)}
            </ul>
            <p className="mt-8 font-serif text-xl italic leading-snug text-amber-light" data-id="element-180" data-mp="d8fnen0ekea">
              Refunds are processed within 2 business days.
            </p>
          </div>
        </div>
      </div>
    </section>;
}